import styles from "./styles.module.scss";

export type ProjectWorkspaceTab = "creators" | "overview";

type ProjectWorkspaceTabsProps = {
  activeTab: ProjectWorkspaceTab;
  onTabChange: (tab: ProjectWorkspaceTab) => void;
};

const TABS: { value: ProjectWorkspaceTab; label: string }[] = [
  { value: "overview", label: "Overview" },
  { value: "creators", label: "Creators" },
];

export function ProjectWorkspaceTabs({
  activeTab,
  onTabChange,
}: ProjectWorkspaceTabsProps) {
  return (
    <div className={styles.tabList} role="tablist" aria-label="Project view">
      {TABS.map((tab) => {
        const isActive = activeTab === tab.value;
        return (
          <button
            key={tab.value}
            type="button"
            role="tab"
            aria-selected={isActive}
            className={`${styles.tabButton} ${isActive ? styles.tabButtonActive : ""}`}
            onClick={() => onTabChange(tab.value)}
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
}
